import './App.css';
import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from './components/MainLayout';
import AdminLayout from './components/AdminDashboard';
import AdminLogin from './components/AdminLogin'; // Make sure this is imported!
import LandingPage from './components/LandingPage';
import ReservationPage from "./components/ReservationPage";
import ProtectedRoute from './components/ProtectedRoute';
import MenuPage from './components/MenuPage';
import Privacy from './components/Privacy';
import Cookie from './components/Cookie';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <Routes>
      {/* Public Customer Routes wrapped in MainLayout */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<LandingPage />} />
        <Route path="reservation" element={<ReservationPage />} />
      </Route>

      {/* Admin Login Route */}
      <Route path="/admin/login" element={<AdminLogin />} />

      <Route path="/menu" element={ <MenuPage /> } />

      {/* Protected Admin Dashboard Route */}
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        } 
      />

      <Route 
        path='/privacy-policy'
        element={<>
        <Header />
        <Privacy />
        <Footer />
        </>}
      />

      <Route path="/cookie-policy" element={<>
        <Header />
        <Cookie />
        <Footer />
      </>} />

      {/* 404 No Page Found Catch-All Route */}
      <Route 
        path="*" 
        element={
          <div style={{ textAlign: 'center', marginTop: '100px' }}>
            <h2>404 - Page Not Found</h2>
            <p>The page you are looking for does not exist.</p>
            <a href="/">Go to Home</a>
          </div>
        } 
      />
    </Routes>
  );
}

export default App;